// Fast File Upload Actions
const action = "INGESTION_UPLOAD";

// Upload actions
export const UPLOAD_REQUEST = action + '_REQUEST';
export const UPLOAD_SUCCESS = action + '_SUCCESS';
export const UPLOAD_FAILURE = action + '_FAILURE';
export const UPLOAD_PROGRESS = action + '_PROGRESS';

// Clear state action
export const CLEAR = action + '_CLEAR';

// Action creators
export const uploadFile = (file, columnTypes, options = {}) => ({
  type: UPLOAD_REQUEST,
  payload: { file, columnTypes, options }
});

export const uploadFileSuccess = (response) => ({
  type: UPLOAD_SUCCESS,
  payload: response
});

export const uploadFileFailure = (error) => ({
  type: UPLOAD_FAILURE,
  payload: error
});

export const uploadProgress = (progress) => ({
  type: UPLOAD_PROGRESS,
  payload: progress
});

export const clearState = () => ({
  type: CLEAR
});
